/**
 * The Material icons the Flutter auth pages use (Icons.visibility, Icons.arrow_back_ios_new, …),
 * as inline SVG with the Material Design paths. They take the current text color.
 */

interface IconProps {
  size?: number | string;
  className?: string;
}

function MaterialIcon({ path, size = 24, className }: IconProps & { path: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d={path} />
    </svg>
  );
}

/** Icons.visibility */
export function VisibilityIcon(props: IconProps) {
  return (
    <MaterialIcon
      {...props}
      path="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    />
  );
}

/** Icons.visibility_off */
export function VisibilityOffIcon(props: IconProps) {
  return (
    <MaterialIcon
      {...props}
      path="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
    />
  );
}

/** Icons.info_outlined */
export function InfoOutlinedIcon(props: IconProps) {
  return (
    <MaterialIcon
      {...props}
      path="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    />
  );
}

/** Icons.arrow_back_ios_new */
export function ArrowBackIosNewIcon(props: IconProps) {
  return <MaterialIcon {...props} path="M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z" />;
}

/** Icons.check */
export function CheckIcon(props: IconProps) {
  return <MaterialIcon {...props} path="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />;
}

/** Icons.check_circle_outline */
export function CheckCircleOutlineIcon(props: IconProps) {
  return (
    <MaterialIcon
      {...props}
      path="M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    />
  );
}

/** Icons.arrow_drop_down_sharp */
export function ArrowDropDownIcon(props: IconProps) {
  return <MaterialIcon {...props} path="M7 10l5 5 5-5z" />;
}

/** Icons.search */
export function SearchIcon(props: IconProps) {
  return (
    <MaterialIcon
      {...props}
      path="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    />
  );
}

/** Icons.close */
export function CloseIcon(props: IconProps) {
  return (
    <MaterialIcon
      {...props}
      path="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    />
  );
}
